<template>
    <!-- Text Info -->
    <text-block-generic :params="{ content: t('initialActions.firstLogin.step2.textInfo') }" />
    <!-- Friendly Name -->
    <input-generic
    :params="friendlyUserNameInput"
    :inputValue="formData.friendlyUsername"
    @onBlur="friendlyUserNameInputValidation"
    @input="[emit('formDataChange', { field: 'friendlyUsername', inputValue: $event }), clearFieldError()]"/>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import InputGeneric from '@/components/generic/inputs/Generic'

/* Vue & Assets */
import { ref } from 'vue'
import { removeAccents, noSpecialCharNoSpace } from '@/assets/scripts/validators'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['formDataChange', 'hasInvalidFields'])

/** props received
@formData { Object } Object with info for our current form
*/
const props = defineProps({
    formData: Object
})

/* Friendly User Name Input */
const friendlyUserNameInput = ref({
    labelText: t('initialActions.firstLogin.step2.friendlyUsernameLabel'),
    bottomMessage: t('initialActions.firstLogin.step2.friendlyUsernameBottomMessage'),
    placeholder: t('initialActions.firstLogin.step2.placeholderFriendlyUsername'),
    maxLength: 15,
    errorState: false,
    errorMessage: '',
    ourMask: {
        parseInputText: value => { return removeAccents(value) },
        validatorFn: value => { return noSpecialCharNoSpace(value) }
    }
})

const friendlyUserNameInputValidation = () => {
    if (props.formData.friendlyUsername.length < 6 && props.formData.friendlyUsername !== '') {
        friendlyUserNameInput.value.errorState = true
        friendlyUserNameInput.value.errorMessage = t('userArea.definitions.friendlyUsername.friendlyUserNameInput.errorMessage')
        emit('hasInvalidFields', true)
    } else {
        emit('hasInvalidFields', false)
    }
}

/**********************************************************************
*                                                                     *
*                          CLEAR ERRORS LOGIC                         *
*                                                                     *
***********************************************************************/
const clearFieldError = () => {
    friendlyUserNameInput.value.errorMessage = ''
    friendlyUserNameInput.value.errorState = false
}
</script>

<style lang="scss" scoped>

</style>
